var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExplore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic:baseline-travel-explore"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.3 16.9C19.7 16.2 20 15.4 20 14.5C20 12 18 10 15.5 10C13 10 11 12 11 14.5C11 17 13 19 15.5 19C16.4 19 17.2 18.7 17.9 18.3L21.1 21.5L22.5 20.1L19.3 16.9ZM15.5 17C14.1 17 13 15.9 13 14.5C13 13.1 14.1 12 15.5 12C16.9 12 18 13.1 18 14.5C18 15.9 16.9 17 15.5 17ZM12 20V22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2C16.84 2 20.87 5.44 21.8 10H19.73C19.4181 8.79184 18.8279 7.67338 18.0066 6.73401C17.1853 5.79465 16.1557 5.06042 15 4.59V5C15 6.1 14.1 7 13 7H11V9C11 9.55 10.55 10 10 10H8V12H10V15H9L4.21 10.21C4.08 10.79 4 11.38 4 12C4 16.41 7.59 20 12 20Z",
    fill: "#FEFEFE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExplore);
export default __webpack_public_path__ + "static/media/explore.28591d241339358c62d5963965cbaa0d.svg";
export { ForwardRef as ReactComponent };